import { useState } from 'react';

export interface KeywordSearchState {
  searchKeyword: string | null;
  setSearchKeyword: React.Dispatch<React.SetStateAction<string | null>>;
}

export const useKeywordSearch = (): KeywordSearchState => {
  const [searchKeyword, setSearchKeyword] = useState<string | null>(null);

  return {
    searchKeyword,
    setSearchKeyword,
  };
};
